import { portalLogoutUrl } from "~/helpers/constUrls"

export default defineNuxtRouteMiddleware((to, _from) => {
  const nuxtApp = useNuxtApp()
  const cookies = nuxtApp.$cookies as any
  const $axios = nuxtApp.$axios
  const rollbar = nuxtApp.$rollbar
  const { startPolling } = useAutoShift()

  if (!cookies) {
    return
  }

  const authClient = cookies.get("authClient")
  const authUId = cookies.get("authUId")
  const authAccessToken = cookies.get("authAccessToken")

  if (!authClient || !authUId || !authAccessToken) {
    console.warn(
      "[DIAGNOSTIC] auth middleware: Missing auth cookies! Redirecting to:",
      portalLogoutUrl(),
      { authClient: !!authClient, authUId: !!authUId, authAccessToken: !!authAccessToken },
    )
    return navigateTo(portalLogoutUrl(), { external: true })
  }

  // アクセスできる状態かどうかを調べる
  startPolling({
    axios: $axios,
    rollbar,
    route: to,
    redirect: (url: string) => navigateTo(url, { external: true }),
  })
})
